module.exports = __webpack_public_path__ + "static/media/envelope.9bde5e8e.svg";